import { intersectionObserverEmits, useIntersectionObserver } from "@/components/organisms/mixins/intersection-observer.mixin"

export const productSuggestionsProps = () => ({
  suggestionProducts: {
    type: [Array, Object],
    required: false,
    default: () => { }
  },
  selectedProduct: {
    type: Object,
    required: false,
    default: null
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  isDisabled: {
    type: Boolean,
    required: false,
    default: false
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  },
  title: {
    type: String,
    required: true,
    default: 'Nous vous suggérons ces produits'
  }
})

export const productSuggestionsEmits = () => ([
  ...intersectionObserverEmits(),
  "addToListe"
])

export const useProductSuggestions = (emit) => {

  const { onIntersect } = useIntersectionObserver({ emit })

  return {
    onIntersect
  }
}